import axios from "axios";

export default axios.create({
baseURL: "https://munyori.co.zw",
headers: {
"Content-type": "multipart/form-data",
"timeout": 1000
}});